
import * as d3 from 'd3'
export default {
  methods: {

    draw_Contents() {
      
      let dataGroup = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.table.x}, ${this.table.y + this.table.headHeight})`)
      .attr('font-family', 'roboto')


      let y_ = 13
      this.rawData.forEach(d=> {

        let row = dataGroup
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .attr('cursor', 'pointer')
        .call(this.call_List, d.SN)

        this.columns.forEach((col,c)=> {
          let x_ = c>3 ? col.tx - 6 : col.tx
          let totCode = col.code.split('_')[0] + '_TOT'

          if(col.type == 'PRO') {
            this.tbl_ProgBar(row, col, d[col.code]) // ----->
          } else if(col.type == 'PA' || col.type == 'PB') {
            this.tbl_PunchBar(row, col, col.type, d) // ----->
          } else if((d[totCode] && d[totCode] > 0) || d[totCode] == undefined){
            row
            .append('text')
            .attr('transform', `translate(${x_}, 0)`)
            .attr('font-size', 10).attr('fill', d[col.code] == 0 ? '#E0E0DF' : '#606060')
            .attr('text-anchor', col.align)
            .text(d[col.code])
            .call(this.event_Link, d, col, x_)
          }
          
        })
        y_ += this.table.lineHeight
      })

    },

    tbl_ProgBar(selection, col, pro) {
      selection
      .append('rect')
      .attr('x', col.sx).attr('y', -9)
      .attr('width', 100).attr('height', 11).attr('fill', '#F4F5F5')

      selection
      .append('rect')
      .attr('x', col.sx).attr('y', -9)
      .attr('width', pro).attr('height', 11).attr('fill', '#B4E3FA')

      selection
      .append('text')
      .attr('x', pro < 60 ? col.sx+pro+1 : col.sx+pro-1).attr('y', 0)
      .attr('font-size', 10)
      .attr('fill', pro == 0 ? '#E0E0DF' : '#606060')
      .attr('text-anchor', pro < 60 ? 'start' : 'end')
      .text(pro+'%')
    },

    tbl_PunchBar(selection, col, cat, data) {

      if(data[`${cat}_TOT`] == 0) return 
      
      let lenTot =  (data[`${cat}_TOT`]/this.punch[cat]) * 100
      let lenPro =  (data[`${cat}_ACT`]/this.punch[cat]) * 100

      selection
      .append('rect')
      .attr('x', col.sx).attr('y', -9)
      .attr('width', lenTot).attr('height', 11)
      .attr('fill', '#F4F5F5')

      selection
      .append('rect')
      .attr('x', col.sx).attr('y', -9)
      .attr('width', lenTot - lenPro).attr('height', 11)
      .attr('fill', '#FCE3EB')

      selection
      .append('text')
      .attr('x', col.sx+(lenTot-lenPro)+1).attr('y', 0)
      .attr('font-size', 10)
      .attr('fill', '#606060')
      .text(data[`${cat}_REM`])
    }

  }
}